import { TREASURY_CONFIRMATION_UI } from "../config/treasuryConfirmation";

/** Informational only: expiry never advances a purchase or enables a payment. */
export function treasuryConfirmationEstimate(startedAt: number | null, now: number) {
  if (startedAt === null || !Number.isFinite(startedAt) || startedAt <= 0 || !Number.isFinite(now)) return null;
  const elapsed = Math.max(0, now - startedAt);
  const seconds = Math.max(0, Math.ceil(TREASURY_CONFIRMATION_UI.estimateSeconds - elapsed / 1000));
  return { delayed: seconds === 0, text: `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}` };
}
